if (!customElements.get('subscription-popup')) {
    customElements.define('subscription-popup', class SubscriptionPopup extends ModalDialog {
        constructor() {
            super();

            this.selectors = {
                cartDrawer: 'cart-drawer'
            };

            this.classes = {
                active: "is-active"
            };

            this.mediaQuery = {
                desktop: '(min-width: 992px)'
            }

            this.attrs = {
              cartDrawerPopup: 'cart-drawer-popup',
              updateSubscriptionPlanPopup: 'update-subscription-plan-popup',
              updateFreePlanPopup: 'update-free-plan-popup',
            };

            this.onHide = this.onHide.bind(this);
            this.cartDrawer = document.querySelector(this.selectors.cartDrawer);
        }

        connectedCallback() {
            document.addEventListener('subscription-popup:hide:trigger', this.onHide);
            document.addEventListener('subscription-popup:show:trigger', (event) => this.show(event.detail.opener));
        }

        disconnectedCallback() {
            document.removeEventListener('subscription-popup:hide:trigger', this.onHide);
            document.removeEventListener('subscription-popup:show:trigger', (event) => this.show(event.detail.opener));
        }

        onHide(event) {
            const type = event?.detail?.type;

            const popupType = this?.dataset?.type;

            if (!type || type === popupType) {
                this.hide();
            }
        }

        hide() {
            if(this.isCartDrawerPopup(this)) {
                this.toggleCartDrawerPopup(null, false);
                return;
            }

            if (this.isUpdateSubscriptionPlanPopup(this)) this.toggleUpdateSubscriptionPlanPopup(false);
            if (this.isUpdateFreePlanPopup(this)) this.toggleUpdateFreePlanPopup(false);

            super.hide();
        }

        show(opener) {
            if (this.isCartDrawerPopup(opener)) {
                this.toggleCartDrawerPopup(opener, true);
                return;
            }

            if (this.isUpdateSubscriptionPlanPopup(opener)) this.toggleUpdateSubscriptionPlanPopup(true);
            if (this.isUpdateFreePlanPopup(opener)) this.toggleUpdateFreePlanPopup(true);

            super.show(opener);
        }

        toggleUpdateSubscriptionPlanPopup(isOpen) {
            this.toggleUpdatePlanTabs(isOpen);
            this.changeUpdatePlanTabs(isOpen);

            document.dispatchEvent(new CustomEvent('subscription:submit-button-text:change', {
                detail: {
                    value: isOpen ? window.subscriptionStrings.updatePlan : window.variantStrings.addToCart
                }
            }));

            !isOpen && document.dispatchEvent(new CustomEvent('subscription:service:account:clear'));

            this.dataset.type = isOpen ? this.attrs.updateSubscriptionPlanPopup : "";
        }

        toggleUpdateFreePlanPopup(isOpen) {
            this.toggleUpdatePlanTabs(isOpen);
            this.changeUpdatePlanTabs(isOpen);

            this.dataset.type = isOpen ? this.attrs.updateFreePlanPopup : "";
        }

        toggleUpdatePlanTabs(isOpen) {
            document.dispatchEvent(new CustomEvent('subscription:tabs:toggle', {
                detail: {
                    isHidden: isOpen
                }
            }));
        }

        changeUpdatePlanTabs(isOpen) {
            isOpen && document.dispatchEvent(new CustomEvent('subscription:tabs:change', {
                detail: {
                    value: 'subscription'
                }
            }));
        }

        isCartDrawerPopup(element) {
            return this.cartDrawer && element.dataset.type === this.attrs.cartDrawerPopup;
        }

        isUpdateSubscriptionPlanPopup(element) {
            return element.dataset.type === this.attrs.updateSubscriptionPlanPopup;
        }

        isUpdateFreePlanPopup(element) {
            return element.dataset.type === this.attrs.updateFreePlanPopup;
        }

        toggleCartDrawerPopup(opener, open) {
            switch (open) {
                case true:
                    this.openCartDrawerPopup = true;
                    this.cartDrawer.addEventListener('transitionend', () => {
                        if(this.openCartDrawerPopup) {
                            this.dataset.type = this.attrs.cartDrawerPopup;
                            super.show(opener);
                        }
                    }, { once: true });

                    this.cartDrawer.close();
                    break;
                case false:
                    this.openCartDrawerPopup = false;
                    super.hide();
                    this.dataset.type = "";
                    break;
            }
        }
    });
}